import moment from "moment";
import Config from "../constants/Config";
import axios from "axios";
import { requiredTimes } from "./requiredTimes";
import { datadogLogs } from "@datadog/browser-logs";
import { ChatHistoryResponse } from "../types";

let config = {
  urls: {
    UK: "https://api-2144.myspetz.com",
    IL: "https://service.2144.co.il",
    oldServerURL: Config.oldServerURL,
    baseURL: Config.baseURL,
  },
  countryCode: "UK",
};

export async function getSubjectSuggestions(text, countryId, languageId) {
  if (text) {
    const values = await fetch(
      `${config.urls.baseURL}/api/search/subjects`,
      connectionOptions(
        {
          categoryId: null,
          countryId,
          text,
          limit: 10,
          languageId,
        },
        [["languageId", languageId]]
      )
    );
    let data = await values.json();
    data = data.map((e) => {
      return { description: e.ServiceName };
    });
    return data;
  } else {
    return [];
  }
}

export function getTimesToCall(country) {
  let alt_vals = [...requiredTimes];
  let currentTime = moment();
  alt_vals = alt_vals.filter(
    (val) => val.hour > currentTime.hour() || val.day > 0
  );
  alt_vals = alt_vals.map((val) => {
    const key = val.day === 0 ? "today" : "tomorrow";
    let required_date = moment()
      .hour(val.hour)
      .set({ minute: 0, second: 0, millisecond: 0 })
      .add(val.day, "days");
    let description = ` - ${
      country && country.Id === 1
        ? required_date.format("HH:mm")
        : required_date.format("hh:mm A")
    }`;
    return {
      value: required_date.valueOf(),
      TextToShow: description,
      key,
    };
  });

  alt_vals.splice(0, 0, {
    TextToShow: "",
    key: "now",
    value: null, //Send null if the chosen time is now (synchronize issue)
  });
  return alt_vals;
}

export async function openServiceCall({
  serviceCall,
  affiliateId,
  countryId,
  campaign,
}) {
  const [address, city] = serviceCall.serviceAreaName.description.split(", ");
  const dateRequired = serviceCall.dateRequired.value
    ? "/Date(" + new Date(serviceCall.dateRequired.value).getTime() + ")/"
    : "/Date(" + new Date().getTime() + ")/";

  let arrangedData = {
    appVersion: "1",
    affiliateID: affiliateId,
    verifyService: false,
    serviceCallType: 1,
    dateRequired: dateRequired,
    address: address,
    city: city || address,
    serviceSubjectName: serviceCall.serviceSubjectName.description,
    serviceAreaName: serviceCall.serviceAreaName.description,
    phoneNumber: serviceCall.phoneNumber,
    description: serviceCall.description,
    clientName: serviceCall.clientName,
    latitude: serviceCall.serviceAreaName.lat,
    longitude: serviceCall.serviceAreaName.long,
    language: Config.browserLng,
    countryId: countryId,
    campaignId: campaign.campaignId,
    clickId: campaign.gclId,
    searchTerm: campaign.searchTerm,
  };

  try {
    const result = await fetch(
      `${config.urls.baseURL}/api/customer/openServiceCall`,
      connectionOptions(arrangedData)
    );
    let data = await result.json();
    if (result.status !== 200) {
      datadogLogs.logger.error(`openServiceCall - server responded with status ${result.status} for the following payload ${JSON.stringify(arrangedData)}`, { payload: arrangedData, response: data });
      throw "connection error";
    }
    else {
      datadogLogs.logger.info(`openServiceCall - opened serviceCall for the following payload ${JSON.stringify(arrangedData)} retrieved the following data ${JSON.stringify(data)}`, { payload: arrangedData, response: data });
    }
    let returnObject = {};
    if (data.Result) {
      // notify the parent of this iframe that the service call has been successfully opened
      if (window.parent)
        window.parent.postMessage("openServiceCallSuccess", "*");

      returnObject = {
        ...arrangedData,
        // dateRequired: serviceCall.time.value ? moment.unix(serviceCall.time.value / 1000).format('L') : moment(Date.now()).format("L"),
        serviceCallId: data["ServiceCallID"],
        grade: data.hasOwnProperty("Grade") ? data["Grade"] : null,
        IsVerifyBySMS: data.hasOwnProperty("IsVerifyBySMS") ? data["IsVerifyBySMS"] : null,
      };
    } else {
      returnObject = {
        err: {
          ErrorCode: data.ErrorCode,
          ErrorMessage: data.ErrorMessage,
        },
      };
    }

    return returnObject;
  } catch (err) {
    return {
      err: {
        ErrorCode: 500,
        ErrorMessage: "error",
      },
    };
  }
}

export async function connect(path, options = {}, noJSON) {
  let connectionPath;
  if (path.indexOf("http") > -1) {
    connectionPath = path;
  } else {
    connectionPath = `${config.urls.oldServerURL + `/` + path}`;
  }

  let res = await fetch(connectionPath, connectionOptions(options));

  if (res.status === 401 && window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage("401");
  }
  // alert(res.status);
  if (noJSON) return res;

  return res.status === 200 ? await res.json() : res;
}

export async function CreateNewLink(providerId, method, token) {
  const payload = {
    messageType: method,
    token: token,
    language: Config.browserLng,
  };
  return await axios
    .post(
      `${config.urls.baseURL}/api/provider/${providerId}/payment-method/setup-intent`,
      payload
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err.response;
    });
}

  // start new chat or get existing chat
  export async function startChat({countryId,affiliateId,sessionId}) {
    const response = await axios.get(`${config.urls.baseURL}/api/chat/start/${countryId}/${affiliateId}/${sessionId}`)
    return response.data;
  }

  export async function sendMessage({message,sessionId}) {
    const response = await axios.post(`${config.urls.baseURL}/api/chat/send/${sessionId}`, {
      Message: message,
    })
    return response.data;
  }


export async function VerifyToken(token) {
  return await axios
    .post(`${config.urls.baseURL}/api/payment-method/setup-intent/${token}/`)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err.response;
    });
}

export async function getCountries() {
  try {
    const res = await axios.get(`${config.urls.baseURL}/api/countries`);
    return res.data;
  } catch (e) {
    const resultError = `Failed getting countries: ${e}`;
    throw new Error(resultError);
  }
}

export function assignPhoneNumber(body) {
    const res = axios.post(
      `${config.urls.baseURL}/api/PhoneNumbers/Assign`,
      {...body}
    );
    return res;
}

export async function getAreaDetails(areaName) {
  try {
    const res = await axios.get(
      `${config.urls.baseURL}/api/serviceAreas/${areaName}`
    );
    return res.data;
  } catch (e) {
    return undefined;
  }
}
export async function getAffiliate(affiliateId) {
  try {
    const res = await axios.get(
      `${config.urls.baseURL}/api/customer/affiliate/${affiliateId}`
    );
    return res.data;
  } catch (e) {
    return undefined;
  }
}

export async function getIframeInfo(countryId) {
  try {
    const res = await axios.get(
      `${config.urls.baseURL}/api/customer/iframeinfo/${countryId}`
    );
    return res.data;
  } catch (e) {
    return undefined;
  }
}

function connectionOptions(body, headersToAdd) {
  // body.language = Config.browserLng
  let headers = new Headers();
  headers.append("Content-Type", "application/json");

  if (headersToAdd) {
    headersToAdd.forEach((header) => headers.append(header[0], header[1]));
  }

  return {
    method: "POST",
    dataType: "jsonp",
    headers: headers,
    body: JSON.stringify(body),
  };
}

export async function sendSMSV2(phoneNumber,countryID) { 
  const payload = {
    phoneNumber: phoneNumber,
    allowRegistration: true,
    retrieveToken: false,
    countryId: countryID
  }
  return await axios
    .post(`${config.urls.baseURL}/api/customer/sendVerificationSmsV2`, payload)
    .catch((err) => {
      console.log("sendSMSV2 Error: ",err)
      return err.response;
    });
}

export async function verifyCode(phoneNumber, code, serviceCallId) { 
  const payload = {
    customerPhone: phoneNumber,
    code,
    serviceCallId
  }
  return await axios
    .post(`${config.urls.baseURL}/api/customer/loginV2`, payload)
    .catch((err) => {
      console.log("sendSMSV2 Error: ",err)
      return err.response;
    });
}